export default "__VITE_ASSET__BeLFgcHx__"